import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Divider,
    Box,
    Alert
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import { useSucursal } from '../contexts/SucursalContext';
import Swal from 'sweetalert2';

const formatLocalDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, '0');
    return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        'T' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds())
    );
};

const ConteoDenominaciones = ({ 
    open, 
    onClose, 
    tipoOperacion, 
    idCajaEncabezado = null
}) => {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const { user } = useUser();
    const { sucursalSeleccionada, actualizarCajaAbierta } = useSucursal();

    const [denominaciones, setDenominaciones] = useState([]);
    const [conteos, setConteos] = useState([]);
    const [totalBilletes, setTotalBilletes] = useState(0);
    const [totalMonedas, setTotalMonedas] = useState(0);
    const [totalGeneral, setTotalGeneral] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [conteoExistente, setConteoExistente] = useState([]);
    const [cajaCreada, setCajaCreada] = useState(null);    useEffect(() => {
        if (open) {
            cargarDenominaciones();
        }
    }, [open]);

    useEffect(() => {
        if (idCajaEncabezado && denominaciones.length > 0) {
            cargarConteoExistente();
        }
    }, [idCajaEncabezado, denominaciones]);

    useEffect(() => {
        calcularTotales();
    }, [conteos]);    const cargarDenominaciones = async () => {
        try {
            console.log('🔄 Iniciando carga de denominaciones...');
            const response = await fetch(`${server}/MgCajaDenominaciones/denominaciones-activas`);
            const data = await response.json();
            
            console.log('📥 Respuesta de denominaciones:', data);
            
            if (response.ok) {
                const denominacionesData = data.$values || data || [];
                console.log('✅ Denominaciones cargadas:', denominacionesData);
                setDenominaciones(denominacionesData);
                
                // Inicializar conteos con campos vacíos
                const conteosIniciales = denominacionesData.map(denom => ({
                    idDenominacion: denom.id,
                    valorDenominacion: denom.valor,
                    tipoDenominacion: denom.tipoDenominacion,
                    cantidadApertura: '',
                    cantidadCierre: '',
                    totalApertura: 0,
                    totalCierre: 0
                }));
                console.log('🔄 Conteos inicializados:', conteosIniciales);
                setConteos(conteosIniciales);
            } else {
                console.error('❌ Error en respuesta de denominaciones:', response.status);
            }
        } catch (error) {
            console.error('❌ Error al cargar denominaciones:', error);
            Swal.fire('Error', 'No se pudieron cargar las denominaciones', 'error');
        }
    };const cargarConteoExistente = async () => {
        try {
            const response = await fetch(`${server}/MgCajaDenominaciones/conteo-por-caja/${idCajaEncabezado}`);
            const data = await response.json();
            
            if (response.ok) {
                const conteoExistenteData = data.$values || data || [];
                setConteoExistente(conteoExistenteData);
                
                // Actualizar conteos con datos existentes solo si hay datos
                if (conteoExistenteData.length > 0) {
                    setConteos(prevConteos => 
                        prevConteos.map(conteo => {
                            const existente = conteoExistenteData.find(c => c.idDenominacion === conteo.idDenominacion);
                            if (existente) {
                                return {
                                    ...conteo,
                                    cantidadApertura: existente.cantidadApertura || 0,
                                    cantidadCierre: existente.cantidadCierre || 0,
                                    totalApertura: existente.totalApertura || 0,
                                    totalCierre: existente.totalCierre || 0
                                };
                            }
                            return conteo;
                        })
                    );
                }
            }
        } catch (error) {
            console.error('Error al cargar conteo existente:', error);
        }
    };    const handleCantidadChange = (idDenominacion, cantidad) => {
        // Si está vacío, mantenerlo vacío
        if (cantidad === '') {
            setConteos(prevConteos => 
                prevConteos.map(conteo => {
                    if (conteo.idDenominacion === idDenominacion) {
                        const campoTotal = tipoOperacion === 'APERTURA' ? 'totalApertura' : 'totalCierre';
                        const campoCantidad = tipoOperacion === 'APERTURA' ? 'cantidadApertura' : 'cantidadCierre';
                        
                        return {
                            ...conteo,
                            [campoCantidad]: '',
                            [campoTotal]: 0
                        };
                    }
                    return conteo;
                })
            );
            return;
        }

        // Convertir a número y validar que no sea negativo
        const cantidadNum = parseInt(cantidad) || 0;
        if (cantidadNum < 0) return; // No permitir números negativos
        
        console.log(`🔢 Actualizando cantidad para denominación ${idDenominacion}: ${cantidadNum}`);
        
        setConteos(prevConteos => {
            const nuevosConteos = prevConteos.map(conteo => {
                if (conteo.idDenominacion === idDenominacion) {
                    const campoTotal = tipoOperacion === 'APERTURA' ? 'totalApertura' : 'totalCierre';
                    const campoCantidad = tipoOperacion === 'APERTURA' ? 'cantidadApertura' : 'cantidadCierre';
                    
                    const conteoActualizado = {
                        ...conteo,
                        [campoCantidad]: cantidadNum,
                        [campoTotal]: cantidadNum * conteo.valorDenominacion
                    };
                    
                    console.log(`✅ Conteo actualizado:`, conteoActualizado);
                    return conteoActualizado;
                }
                return conteo;
            });
            
            console.log('📊 Todos los conteos después de actualización:', nuevosConteos);
            return nuevosConteos;
        });
    };

    const calcularTotales = () => {
        const billetes = conteos
            .filter(c => c.tipoDenominacion === 'BILLETE')
            .reduce((sum, c) => {
                const total = tipoOperacion === 'APERTURA' ? c.totalApertura : c.totalCierre;
                return sum + total;
            }, 0);

        const monedas = conteos
            .filter(c => c.tipoDenominacion === 'MONEDA')
            .reduce((sum, c) => {
                const total = tipoOperacion === 'APERTURA' ? c.totalApertura : c.totalCierre;
                return sum + total;
            }, 0);

        setTotalBilletes(billetes);
        setTotalMonedas(monedas);
        setTotalGeneral(billetes + monedas);
    };    const handleGuardar = async () => {
        if (conteos.length === 0) {
            Swal.fire('Error', 'No hay denominaciones cargadas', 'error');
            return;
        }

        // Validar que no todo esté en cero (aplica para APERTURA y CIERRE)
        const todoEnCero = conteos.every(conteo => {
            const cantidadApertura = conteo.cantidadApertura === '' ? 0 : parseInt(conteo.cantidadApertura) || 0;
            const cantidadCierre = conteo.cantidadCierre === '' ? 0 : parseInt(conteo.cantidadCierre) || 0;
            const cantidad = tipoOperacion === 'APERTURA' ? cantidadApertura : cantidadCierre;
            return cantidad === 0;
        });

        if (todoEnCero) {
            const mensaje = tipoOperacion === 'APERTURA' 
                ? 'No puede realizar una apertura de caja con todas las denominaciones en cero. Por favor, ingrese las cantidades correctas de billetes y monedas que tiene en caja.'
                : 'No puede realizar un conteo físico de cierre con todas las denominaciones en cero. Por favor, ingrese las cantidades correctas de billetes y monedas que tiene en caja.';
            
            Swal.fire({
                title: 'Advertencia',
                text: mensaje,
                icon: 'warning',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        setIsLoading(true);

        try {
            let idCajaAUsar = idCajaEncabezado || cajaCreada;

            // Si es APERTURA y no hay ID de caja, crear la caja primero con el total como valor de inicio
            if (tipoOperacion === 'APERTURA' && !idCajaAUsar) {
                console.log('🏦 Creando caja nueva con valor de inicio:', totalGeneral);
                try {
                    idCajaAUsar = await crearCajaApertura(totalGeneral);
                } catch (error) {
                    // El error ya fue mostrado en crearCajaApertura
                    setIsLoading(false);
                    return;
                }
            }

            if (!idCajaAUsar) {
                // Solo mostrar este error si no es el caso de caja ya abierta
                if (tipoOperacion !== 'APERTURA') {
                    Swal.fire('Error', 'No se pudo obtener el ID de la caja', 'error');
                }
                setIsLoading(false);
                return;
            }

            // Preparar conteos para enviar (aceptar conteos en cero)
            const conteosParaEnviar = conteos
                .map(conteo => {
                    const cantidad = tipoOperacion === 'APERTURA' ? conteo.cantidadApertura : conteo.cantidadCierre;
                    // Convertir a número, si está vacío será 0
                    const cantidadNum = cantidad === '' ? 0 : parseInt(cantidad) || 0;
                    const total = cantidadNum * conteo.valorDenominacion;
                    
                    return {
                        IdDenominacion: conteo.idDenominacion,
                        Cantidad: cantidadNum,
                        Total: total
                    };
                });            // Permitir conteos en cero sin mostrar mensaje de confirmación para apertura
            if ((conteosParaEnviar.reduce((sum, conteo) => sum + conteo.Total, 0) === 0) && tipoOperacion === 'APERTURA' && !idCajaEncabezado) {
                // Para apertura sin caja existente, aceptar conteo en cero sin confirmación
                console.log('Abriendo caja con conteo en cero');
            }

            let usuario = user?.codigoUsuario || 'SISTEMA';

            const payload = {
                IdCajaEncabezado: idCajaAUsar,
                TipoOperacion: tipoOperacion,
                Usuario: usuario,
                Conteos: conteosParaEnviar
            };

            console.log('🚀 PAYLOAD FINAL:', JSON.stringify(payload, null, 2));

            const response = await fetch(`${server}/MgCajaDenominaciones/guardar-conteo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                if (tipoOperacion === 'APERTURA') {
                    Swal.fire('Éxito', 'Caja iniciada correctamente con conteo físico de denominaciones', 'success');
                } else {
                    Swal.fire('Éxito', `Conteo de ${tipoOperacion.toLowerCase()} guardado correctamente`, 'success');
                }
                onClose();
            } else {
                const errorData = await response.json();
                console.error('Error del servidor:', errorData);
                Swal.fire('Error', errorData.message || 'Error al guardar el conteo', 'error');
            }
        } catch (error) {
            console.error('Error al guardar conteo:', error);
            Swal.fire('Error', 'Error al procesar la operación', 'error');
        } finally {
            setIsLoading(false);
        }    };

    const crearCajaApertura = async (valorInicio) => {
        try {
            const now = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            const formattedDate = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

            const data = {
                ingresadoPor: user.codigoUsuario,
                valorInicio: parseFloat(valorInicio),
                usuarioAutoriza: 'N/A',
                fechahorainicio: formattedDate,
                idSucursal: sucursalSeleccionada.idSucursal
            };

            console.log('Creando caja con datos:', data);

            const response = await fetch(`${server}/MgCajaEncabezadoArqueos`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                const responseData = await response.json();
                const idCaja = responseData.id || responseData.idCaja || responseData.idEncabezado || responseData;
                console.log('ID de caja creada:', idCaja);
                setCajaCreada(idCaja);
                actualizarCajaAbierta();
                return idCaja;
            } else {
                // Leer como texto primero para evitar error de JSON inválido
                const errorText = await response.text();
                let errorMessage = 'Error al crear la caja';
                
                try {
                    const errorData = JSON.parse(errorText);
                    errorMessage = errorData.message || errorData.Message || errorData.title || errorMessage;
                } catch (parseError) {
                    // El backend devolvió texto plano (ej. excepción .NET)
                    errorMessage = errorText || errorMessage;
                }
                
                // Mostrar el mensaje de error específico que viene del API
                if (errorMessage.includes('ya tiene una caja abierta')) {
                    Swal.fire({
                        title: '⚠️ Caja Ya Abierta',
                        text: errorMessage,
                        icon: 'warning',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#f44336',
                        html: `
                            <div style="text-align: left; margin: 20px 0;">
                                <p><strong>🚫 No se puede abrir una nueva caja</strong></p>
                                <p>${errorMessage}</p>
                                <hr style="margin: 15px 0;">
                                <p><strong>📋 Pasos a seguir:</strong></p>
                                <ol style="text-align: left; padding-left: 20px;">
                                    <li>Vaya a la sucursal donde tiene la caja abierta</li>
                                    <li>Complete el cierre de caja correspondiente</li>
                                    <li>Regrese e intente abrir la nueva caja</li>
                                </ol>
                            </div>
                        `,
                        width: 500
                    });
                } else {
                    Swal.fire('Error', errorMessage, 'error');
                }
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Error al crear caja:', error);
            Swal.fire('Error', 'No se pudo crear la caja: ' + error.message, 'error');
            throw error;
        }
    };

    const renderTablaDenominaciones = (tipo) => {
        const denominacionesFiltradas = conteos.filter(c => c.tipoDenominacion === tipo);
        
        return (
            <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Denominación</TableCell>
                            <TableCell align="center">Cantidad</TableCell>
                            <TableCell align="right">Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {denominacionesFiltradas.map((conteo) => {
                            const cantidad = tipoOperacion === 'APERTURA' ? conteo.cantidadApertura : conteo.cantidadCierre;
                            const total = tipoOperacion === 'APERTURA' ? conteo.totalApertura : conteo.totalCierre;
                            
                            return (
                                <TableRow key={conteo.idDenominacion}>
                                    <TableCell>
                                        {tipo === 'BILLETE' ? 'L. ' : 'L. '}{conteo.valorDenominacion.toFixed(2)}
                                    </TableCell>
                                    <TableCell align="center">
                                        <TextField
                                            type="number"
                                            size="small"
                                            // value={cantidad}
                                            value={cantidad === 0 ? "" : cantidad}
                                            onChange={(e) => handleCantidadChange(conteo.idDenominacion, e.target.value)}
                                            inputProps={{ min: 0 }}
                                            sx={{ width: 80 }}
                                            placeholder="0"
                                        />
                                    </TableCell>
                                    <TableCell align="right">
                                        L. {total.toFixed(2)}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {tipoOperacion === 'APERTURA' && !idCajaEncabezado
                    ? 'Iniciar Caja - Conteo Físico de Denominaciones'
                    : `Conteo Físico de Denominaciones - ${tipoOperacion}`
                }
            </DialogTitle>
            <DialogContent>
                <Alert severity={tipoOperacion === 'APERTURA' ? "info" : "warning"} sx={{ mb: 2 }}>
                    {tipoOperacion === 'APERTURA' && !idCajaEncabezado
                        ? 'Ingrese la cantidad física de cada denominación. La suma total será el valor de inicio de la caja.'
                        : 'Ingrese la cantidad física de cada denominación que tiene en caja'
                    }
                </Alert>

                <Typography variant="h6" gutterBottom>
                    Billetes
                </Typography>
                {renderTablaDenominaciones('BILLETE')}

                <Typography variant="h6" gutterBottom>
                    Monedas
                </Typography>
                {renderTablaDenominaciones('MONEDA')}

                <Divider sx={{ my: 2 }} />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="body1">
                        <strong>Total Billetes: L. {totalBilletes.toFixed(2)}</strong>
                    </Typography>
                    <Typography variant="body1">
                        <strong>Total Monedas: L. {totalMonedas.toFixed(2)}</strong>
                    </Typography>
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" color="primary">
                        <strong>TOTAL GENERAL: L. {totalGeneral.toFixed(2)}</strong>
                    </Typography>
                    {tipoOperacion === 'APERTURA' && !idCajaEncabezado && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Este será el valor de inicio de la caja
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary" disabled={isLoading}>
                    Cancelar
                </Button>
                <Button 
                    onClick={handleGuardar} 
                    color="primary" 
                    variant="contained"
                    disabled={isLoading || !tienePermiso('Guardar Conteo Denominaciones')}
                >
                    {isLoading ? 'Procesando...' : 
                     tipoOperacion === 'APERTURA' && !idCajaEncabezado ? 'Iniciar Caja' : 'Guardar Conteo'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConteoDenominaciones;
